import { render, staticRenderFns } from "./TracerStudyMagister.vue?vue&type=template&id=cf4e1eca"
import script from "./TracerStudyMagister.vue?vue&type=script&lang=js"
export * from "./TracerStudyMagister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports